<template>
  <van-collapse v-model="activeName" accordion>
    <van-collapse-item
      v-for="(item, index) in list"
      :name="index"
      :key="index"
      :title="item.customerName"
    >
      <div class="content">
        <div class="list">
          <span class="list-left">开团时间</span>
          <span class="list-right">{{ item.createdTime }}</span>
        </div>
        <div class="list">
          <span class="list-left">商品名称</span>
          <span class="list-right">{{ item.goodsName }}</span>
        </div>
        <div class="list">
          <span class="list-left">拼团状态</span>
          <span class="list-right">{{ item.statusExcel }}</span>
        </div>
        <div class="list">
          <span class="list-left">成团数</span>
          <span class="list-right">{{ item.teamNumber }}</span>
        </div>
        <div class="list">
          <span class="list-left">团成员</span>
          <span class="list-right">{{ item.joinNumber }}</span>
        </div>
        <div class="list">
          <span class="list-left">实付价格</span>
          <span class="list-right">{{ item.statusExcel }}</span>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activeName: [],
    };
  },
};
</script>
<style lang="stylus" scoped>
.content {
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 0;
    color: #999999;
    font-size: 14px;
    .list-right {
      position relative
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 230px;
      flex-wrap: wrap;
      color: #333333;
    }
  }
}
</style>
